import {
	Model,
	User,
	YardTrip
} from ".";

export default class Driver extends Model {
	get singularNoun() {
		return "driver";
	}

	get mutations() {
		return {
			trips: YardTrip,
			user: User
		};
	}

	resource() {
		return "yard/drivers";
	}
}
